/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { DecimalFieldItemEdit } from "./edit-item";

const DecimalFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <DecimalFieldItemEdit />
        </FieldListEditWrapper>
    );
};
DecimalFieldEdit.displayName = "DecimalFieldEdit";
export { DecimalFieldEdit };
